import React from 'react';
import { Link } from "react-router-dom";

const Submission = () => (
  <section className="container min-vh-100 pt-5 d-flex justify-content-center align-items-center">
    <div className="jumbotron bg-transparent shadow">
      <h1 className="display-4">Thanks!</h1>
      <p className="lead">
        The form was submitted successfully. Return to <Link title="Homepage" className="text-info" to="/">Homepage</Link>.
      </p>
    </div>
  </section>
);

export default Submission;